import { useEffect, useState, useRef, useContext } from "react";
import { useHistory, useLocation, Link } from 'react-router-dom';

import { LayoutContext } from "../layout/";
import { getEndpoint } from "../helper";

function RatingStars({ score, onSubmitScore }) {
    const [hovered, setHovered] = useState(null);

    const emptyPath = "M16 19.031l5 3-1.313-5.688 4.438-3.875-5.875-0.5-2.25-5.375-2.25 5.375-5.875 0.5 4.438 3.875-1.313 5.688zM29.313 10.781l-7.25 6.313 2.188 9.375-8.25-5-8.25 5 2.188-9.375-7.25-6.313 9.563-0.813 3.75-8.813 3.75 8.813z";

    const fullPath = "M16 21.469l-8.25 5 2.188-9.375-7.25-6.313 9.563-0.813 3.75-8.813 3.75 8.813 9.563 0.813-7.25 6.313 2.188 9.375z";

    return (
        <div style={{ display: "flex", gap: "4px" }}>
            {[1, 2, 3, 4, 5].map((star) => {
                const isFull = hovered >= star || score >= star;

                return (
                    <svg
                        key={star}
                        className="c-p"
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        onMouseEnter={() => setHovered(star)}
                        onMouseLeave={() => setHovered(null)}
                        onClick={() => onSubmitScore(star)}
                    >
                        <path
                            fill={isFull ? "#158c7f" : "#777777"}
                            d={isFull ? fullPath : emptyPath}
                        />
                    </svg>
                );
            })}
        </div>
    );
}

export default function Drawer({ open, children, toggleDrawer }) {
    const [showScorePopup, setShowScorePopup] = useState(false);
    const [score, setScore] = useState(0);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { mobile } = useContext(LayoutContext);
    const history = useHistory();
    const location = useLocation();

    const handleSubmitScore = (score) => {
        fetch(getEndpoint(`/api/android/user/submitscore?username=${mobile}&score=${score}`))
            .then(res => setScore(score))
            .catch(err => console.log(err));
    }

    const handleToggleScorePopup = () => {
        fetch(getEndpoint(`/api/android/user/getscore?username=${mobile}`))
            .then(res => res.json())
            .then(data => {
                setScore(data.data);
                setShowScorePopup(true);
            })
            .catch(err => console.log(err));
    }

    const handleLogout = () => {
        fetch(getEndpoint(`/api/android/auth/DeleteCookie`), { credentials: 'include' })
            .then(_ => history.push('/welcome'))
            .catch(err => console.log(err));
    }

    const handleShare = async e => {
        await navigator.share({
            title: 'تامین 360',
            text: 'خرید آسان ، سریع و مطمئن کالاهای صنعت ساختمان با سامانه تامین۳۶۰. جهت دانلود اپلیکیشن به وبسایت مراجعه کنید:',
            url: 'https://tamin360.ir'
        });
    }

    const Star = () => (
        <div className='d-l d-f jc-c mt-4 mb-5'>
            <RatingStars score={score} onSubmitScore={score => handleSubmitScore(score)} />
        </div>
    );

    return (
        <>
            <nav className={`w-32 bc-w h-100vh p-f t-0 r-0 zi-70 ${(open ? 'open' : '')}`} style={{ maxWidth: '84vw' }}>
                <div className="p-4 c-w _bc-h">
                    <div className="d-f ai-c">
                        <img src={getEndpoint("/pwa/img/logo.png")} style={{ width: '9rem' }} />
                        <div className="mr-4">
                            <div className="fs-4 mb-3">{mobile}</div>
                            <Link to='/profile'>نمایش اطلاعات پروفایل</Link>
                        </div>
                    </div>
                </div>
                <ul className="px-4 pt-4">
                    <li>
                        <button className="d-f ai-c mr-1 py-4 f:o-n" onClick={handleToggleScorePopup}>
                            <img src={getEndpoint("/pwa/img/icons/star.svg")} />
                            <div className="mr-3">امتیاز به برنامه</div>
                        </button>
                    </li>
                    <li>
                        <button className="d-f ai-c mr-1 py-4 f:o-n" onClick={handleShare}>
                            <img src={getEndpoint("/pwa/img/icons/share.svg")} />
                            <div className="mr-3">به اشتراک گذاری</div>
                        </button>
                    </li>
                    <li>
                        <Link className="d-f ai-c mr-1 py-4" to="/return-policy">
                            <img src={getEndpoint("/pwa/img/icons/refresh2.svg")} />
                            <div className="mr-3">مرجوع کالا</div>
                        </Link>
                    </li>
                    <li className="bbw-2 bbc-b pb-4">
                        <Link className="d-f ai-c mr-1 py-4" to="/about-us">
                            <img src={getEndpoint("/pwa/img/icons/info.svg")} />
                            <div className="mr-3">درباره تامین 360</div>
                        </Link>
                    </li>
                    <li className="pt-4">
                        <button type='button' className="d-f ai-c mr-1 py-4" onClick={handleLogout}>
                            <img src={getEndpoint("/pwa/img/icons/logout.svg")} />
                            <div className="mr-3">خروج</div>
                        </button>
                    </li>
                </ul>
            </nav>
            <div onClick={toggleDrawer} className={`overlay h-100 w-100 p-f l-0 t-0 zi-60 ${(open ? 'open' : '')}`}></div>

            {showScorePopup && (
                <div className='p-f l-0 t-0 w-100vw h-100vh d-f ai-fe' style={{ zIndex: 200 }}>
                    <div className='p-f l-0 t-0 w-100vw h-100vh zi-80' style={{ backgroundColor: 'rgba(0,0,0, .5)' }} onClick={e => setShowScorePopup(!showScorePopup)} />
                    <div className='p-r bc-w zi-90 p-4 fs-3 bsh-2 w-100'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 32 32" className='mx-a'>
                            <path fill='#ffa200' d="M16 21.781q-2.313 0-4.156-1.281t-2.656-3.344h2.188q1.563 2.625 4.625 2.625t4.625-2.625h2.188q-0.813 2.063-2.656 3.344t-4.156 1.281zM16 25.156q4.375 0 7.531-3.156t3.156-7.531-3.156-7.531-7.531-3.156-7.531 3.156-3.156 7.531 3.156 7.531 7.531 3.156zM16 1.156q5.5 0 9.406 3.906t3.906 9.406-3.906 9.406-9.406 3.906-9.406-3.906-3.906-9.406 3.906-9.406 9.406-3.906zM11.313 13.156q-0.813 0-1.406-0.594t-0.594-1.406 0.594-1.406 1.406-0.594 1.406 0.594 0.594 1.406-0.594 1.406-1.406 0.594zM20.688 13.156q-0.813 0-1.406-0.594t-0.594-1.406 0.594-1.406 1.406-0.594 1.406 0.594 0.594 1.406-0.594 1.406-1.406 0.594z"></path>
                        </svg>
                        <div className='ta-c mt-5 lh-3'>
                            با امتیاز به تامین 360
                            <br />
                            ما را در ارائه خدمات بهتر یاری کنید
                        </div>
                        <Star />

                        <a href='https://play.google.com/store/apps/details?id=com.tamin360.app' target='_blank' className='d-f jc-c fs-2 c-w br-4 w-100 py-2' style={{ backgroundColor: '#4caf50' }}>
                            ارسال نظر
                        </a>
                    </div>
                </div>
            )}
        </>
    );
}